import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "@src/api/config";
import { showModalSuccess } from "@src/redux/modalTypeSuccess";
import { AppDispatch } from "@src/redux/store";
import { hideModalCustom } from '@src/redux/modalTypeCustom';

export interface DocumentationState {
  loading: boolean;
  data: any | null;
  current: any | null;
}

export const getDocumentation = createAsyncThunk<
  any,
  { entity: "contractors" | "companies"; id: string | number }
>("documentation/get", async ({ entity, id }) => {
  const response = await api.get(`api/${entity}/${id}/documents`);
  return {
    data: response.data
  };
});

export const getDocumentById = createAsyncThunk<
  any,
  { entity: "contractors" | "companies"; docId: string | number }
>("documentation/getDocument", async ({ entity, docId }) => {
  const response = await api.get(`api/documents/${docId}`);
  return {
    data: response.data
  };
});

export const updateDocumentStatus = createAsyncThunk<
  any,
  {
    docId: string | number;
    status: "approved" | "rejected";
    returnUrl: string;
  },
  { dispatch: AppDispatch }
>("documentation/updateStatus", async ({ docId, status, returnUrl }, { dispatch }) => {
  const response = await api.put(`api/documents/updateStatus/${docId}`, {
    status
  });

  const verb = status === "approved" ? "aceptado" : "rechazado";
  dispatch(hideModalCustom());

  await dispatch(
    showModalSuccess({
      message: `El documento ha sido ${verb} con éxito`,
      url: returnUrl
    })
  );

  return {
    data: response.data
  };
});

const initialState: DocumentationState = {
  loading: false,
  data: null,
  current: null
};

const documentationSlice = createSlice({
  name: "documentation",
  initialState,
  reducers: {
    resetDocumentation: (state) => {
      state.loading = false;
      state.data = null;
      state.current = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getDocumentation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDocumentation.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
    });
    builder.addCase(getDocumentation.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getDocumentById.fulfilled, (state, action) => {
      state.current = action.payload.data?.data ?? action.payload.data;
    });
  }
});

export const { resetDocumentation } = documentationSlice.actions;

export default documentationSlice.reducer;
